import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useTouchManage from '../../hooks/useTouchManage'

import useStyles from './styles'

function ActionText({ children, className, onClick }) {
  const classes = useStyles()

  const { t } = useTranslation()

  const { isTouched, touchStartEvent } = useTouchManage()

  return (
    <span
      onClick={onClick}
      onTouchStart={touchStartEvent}
      className={classnames(classes.actionText, className, { isTouched })}
    >
      {t(children)}
    </span>
  )
}

ActionText.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default ActionText
